var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2955 17.0299C13.8562 17.4692 13.1438 17.4692 12.7045 17.0299L7.0795 11.4049C6.64017 10.9655 6.64017 10.2532 7.0795 9.81388C7.51885 9.37454 8.23115 9.37454 8.6705 9.81388L13.5 14.6434L18.3295 9.81388C18.7688 9.37454 19.4812 9.37454 19.9205 9.81388C20.3598 10.2532 20.3598 10.9655 19.9205 11.4049L14.2955 17.0299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropArrow);
export default __webpack_public_path__ + "static/media/dropArrow.ac55742185215ea8939434a3ed9a3a89.svg";
export { ForwardRef as ReactComponent };